import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Column, ConfirmationModal, Spacing, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useIoContext } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
export const IMPORT_REQUEST_FORM_URL = 'https://forms.gle/Q9sMHXFcp5Fs866FA';
export const GetImportRequestModalTID = (parentTestId)=>getTestIds(parentTestId);
export const ImportRequestModal = (param)=>{
    let { textsPath, bi, dismissModal, testId } = param;
    const { ImportRequestModalTID: TID } = useMemo(()=>GetImportRequestModalTID(testId), [
        testId
    ]);
    const { t: importRequestTexts } = useLocaleKeys(textsPath);
    const { browser } = useIoContext();
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        testId: TID.Root(),
        bi: {
            primaryButton: bi.completeForm,
            secondaryButton: bi.close
        },
        textAlignCenter: false,
        title: importRequestTexts.title(),
        primaryButtonLabel: importRequestTexts.completeForm(),
        primaryButtonTestId: TID.CompleteFormButton(),
        onPrimaryButtonClick: ()=>{
            browser.openNewTab(IMPORT_REQUEST_FORM_URL);
        },
        secondaryButtonLabel: importRequestTexts.close(),
        secondaryButtonTestId: TID.CloseButton(),
        onSecondaryButtonClick: dismissModal,
        onCloseButtonClick: dismissModal,
        content: /*#__PURE__*/ _jsxs(Column, {
            gap: Spacing.Space8,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    testId: TID.Body(),
                    children: importRequestTexts.body()
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph2",
                    testId: TID.Note(),
                    children: importRequestTexts.note()
                })
            ]
        })
    });
};
